module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--1-724a9d0a.png";